export default __webpack_public_path__ + "static/media/jarvis_bg.96be7287.png";